// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"44cfd723","247":"4a02f8f9","317":"f7a0db0c","358":"39c5fd1b","521":"5aa18cd6","614":"cb09851c","678":"6bdbd685"}[chunkId] + ".chunk.js";
};